import ConnectionBase from "./ConnectionBase";
export class Connection extends ConnectionBase {
    constructor(user = 'user', pass = 'password', uriBase = '', apiPoint = '') {
        super(user, pass, uriBase, apiPoint);
    }

    async auth() {
        const result = await this.authorize('signin');
        return result;
    }

    async register(registerData) {
        let conStr = this.entryPoint + 'signup';
        let body = JSON.stringify(registerData);

        let result = await this.sendRequest('POST', conStr, body);
        return result;
    }

    async confirmRegistration(userPhone, confirmCode) {
        //console.debug(encodeURIComponent(userPhone));
        let conStr = this.entryPoint + `signup?code=${encodeURIComponent(confirmCode)}&userPhone=${encodeURIComponent(userPhone)}`;
        let result = await this.sendRequest('GET', conStr, null);
        if (result.error === 0){
            this.connection.token = result.data.token;
            this.headers['Authorization'] = 'Bearer ' + this.connection.token;
            this.connection.connected = true;
            //console.log(result);
        } else {
            this.connection.connected = false;
        }
        return result;
    }

    async getUserInfo(userId){
        let conStr = this.entryPoint + `users?userId=${userId}`;
        let result = await this.sendRequest('GET', conStr, null);
        return result;   
    }

    async getUserPatients(userId) {
        let conStr = this.entryPoint + `bindlist/${userId}`;
        let result = await this.sendRequest('GET', conStr, null);
        return result;           
    }

    async getPatientVisits(patientId){
        let conStr = this.entryPoint + `history/${patientId}`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;       
    }

    async getPatientAppointments(patientId, from = undefined){
        const dateFrom = from ? `&dateFrom=${from}` : ''
        const conStr = this.entryPoint + `appointments/filtered?patientId=${patientId}${dateFrom}`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;       
    }

    async getPracticeList(){
        let conStr = this.entryPoint + `practices`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;              
    }

    async getDoctorList(practiceId, guestAccess = false) {
        const practiceParam = (practiceId ? `&practiceId=${practiceId}` : '');
        const guestParam = (guestAccess ? `&guestAccess=1` : '');
        let conStr = this.entryPoint + `staff?appBookRequired=1` + practiceParam + guestParam;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;            
    }

    async getDoctorsReasonsList() {
        const guestParam = `?guestAccess=1`;
        let conStr = this.entryPoint + `availabledoctors` + guestParam;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;            
    }    

    async getAppBooksList(practiceId, guestAccess = false, cdActive = true ) {
        const practiceParam = (practiceId ? `?practiceId=${practiceId}` : '');
        const guestParam = (guestAccess ? `&guestAccess=1` : '&guestAccess=0');
        const cdActiveParam = (cdActive ? `&isCDActive=1` : '&isCDActive=0');
        let conStr = this.entryPoint + `appbooks` + practiceParam + guestParam + cdActiveParam;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;            
    }

    async getUsersList() {
        let conStr = this.entryPoint + `users`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;            
    }

    async getWaitingForConfirmationUsers(){
        let conStr = this.entryPoint + `userrequests`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;   
    }

    async getPatientsD4W(){
        let conStr = this.entryPoint + `patients`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;      
    }

    async getPatientsD4W(params){
        const patId = (params?.patientId ? `&patientId=${params.patientId}` : '');
        const surname = (params?.surname ? `&surname=${params.surname}` : '');
        const firstname = (params?.firstname ? `&firstname=${params.firstname}` : '');
        const middlename = (params?.middlename ? `&middlename=${params.middlename}` : '');
        const dobFrom = (params?.dobFrom ? `&dobFrom=${params.dobFrom}` : '');
        const dobTo = (params?.dobTo ? `&dobTo=${params.dobTo}` : '');
        const mobile = (params?.mobile ? `&mobile=${params.mobile}` : '');
         
        let conStr = this.entryPoint + `patients?dummy=0`+ patId + surname + firstname + middlename + dobFrom + dobTo;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;      
    }

    async createD4WPatient(patientInfo){
        let conStr = this.entryPoint + 'patients'
        let body = JSON.stringify(patientInfo);
        let result = await this.sendRequest('POST', conStr, body); 
        return result;      
    }

    async updateD4WPatient(patientInfo){
        let conStr = this.entryPoint + 'patients'
        let body = JSON.stringify(patientInfo);
        let result = await this.sendRequest('PUT', conStr, body); 
        return result;      
    }
    async getServerVersion(){
        let conStr = this.entryPoint + `status`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;      
    }

    async bindUserAndPatient(userId, patientD4wId){
        let conStr = this.entryPoint + `createandbind`;
        let body = JSON.stringify({
            "userId": userId,
            "patientD4wId": patientD4wId,
        });
        let result = await this.sendRequest('POST', conStr, body); 
        return result;      
    }

    async disconnectPatient(linkId) {
        let conStr = this.entryPoint + `bind/${linkId}`;
        let result = await this.sendRequest('DELETE', conStr, null); 
        return result;           
    }

    async resetPassword(phone){
        let conStr = this.entryPoint + `resetpwd`;
        let body = JSON.stringify({
            "phone": phone,
        });
        let result = await this.sendRequest('POST', conStr, body); 
        return result;  
    }

    async setNewPassword(userPhone, resetCode, password){
        let conStr = this.entryPoint + `resetpwd`;
        let body = JSON.stringify({
            "code": resetCode,
            "password": password,
            "phone": userPhone,
        });
        let result = await this.sendRequest('PUT', conStr, body); 
        return result; 
    }

    async getDoctorFreeAppointments(appBookId, fromDate, toDate){
        let conStr = this.entryPoint + `freeappointments?appBookId=${appBookId}&dateFrom=${fromDate}&dateTo=${toDate}&groupResults=1`;
        let result = await this.sendRequest('GET', conStr, null); 
        return result;                   
    }

    async makeAppointment(practiceId, patientId, appBookId, doctorId, appDate, appTime, appTimeEnd, appDescription, appNotes){
        let conStr = this.entryPoint + `appointments`;
        let body = JSON.stringify({
            "practiceId": practiceId,
            "patientId": patientId,
            "appBookId": appBookId,
            "doctorId": doctorId,
            "appointmentDate": appDate,
            "appointmentTime": appTime,
            "appointmentTimeEnd": appTimeEnd,
            "description": appDescription,
            "notes": appNotes,
        });
        let result = await this.sendRequest('POST', conStr, body); 
        return result; 
    }

    async deleteAppointment(appBookId, appDate, appointId){
        let conStr = this.entryPoint + `appointments`;
        let body = JSON.stringify({
            "appBookId": appBookId,
            "appointmentDate": appDate,
            "appointId": appointId,
        });
        let result = await this.sendRequest('DELETE', conStr, body); 
        return result; 
    }

    async updateLPatient(data){
        let conStr = this.entryPoint + `lpatients`;
        let body = JSON.stringify(data);
        let result = await this.sendRequest('PUT', conStr, body); 
        return result;         
    }

    async deleteUserPhoto(){
        let conStr = this.entryPoint + `users/image`;
        let result = await this.sendRequest('DELETE', conStr, null); 
        return result;            
    }

    async saveUserData(userData){
        let conStr = this.entryPoint + `users`;
        let body = JSON.stringify(userData);
        let result = await this.sendRequest('PUT', conStr, body); 
        return result; 
    }    

    GetDoctorImageUri(appBookId){
        return `${this.uri}/api/v1/staff/image/${appBookId}`
    }
}

const uri = new URL(window.location.href);
const uriBase = uri.protocol+'//'+uri.hostname+(uri.port?`:${uri.port}`:'');
//console.log(uriBase);
var connector = new Connection('','',uriBase, 'api/v1');
export default connector;